// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type Options,
} from '@hey-api/client-fetch';
import type {
  UpdateNotificationData,
  UpdateNotificationResponse,
  FindNotificationsData,
  FindNotificationsResponse,
  GetActivityLogByIdData,
  GetActivityLogByIdResponse,
  FindActivityLogsData,
  FindActivityLogsResponse,
  CreateChatMessageData,
  CreateChatMessageResponse,
  CreateChatData,
  CreateChatResponse,
  GenerateItemDescriptionData,
  GenerateItemDescriptionResponse2,
  ProxyAiRequestData,
  ProxyAiRequestResponse2,
  CreateExportItemsJobData,
  CreateExportItemsJobResponse,
  DeleteExportJobData,
  DeleteExportJobResponse,
  GetExportJobByIdData,
  GetExportJobByIdResponse,
  FindExportJobsData,
  FindExportJobsResponse,
  GetCubeAuthTokenData,
  GetCubeAuthTokenResponse,
  GetReportByExportJobIdData,
  GetReportByExportJobIdResponse,
  CreateAssetGroupData,
  CreateAssetGroupResponse,
  CreateAssetItemData,
  CreateAssetItemResponse,
  DeleteAssetGroupData,
  DeleteAssetGroupResponse,
  UpdateAssetGroupData,
  UpdateAssetGroupResponse,
  DeleteAssetItemData,
  DeleteAssetItemResponse,
  UpdateAssetItemData,
  UpdateAssetItemResponse,
  FindItemAssetsData,
  FindItemAssetsResponse,
  GetAssetDownloadUrlData,
  GetAssetDownloadUrlResponse,
  GetOrganizationUploadUrlData,
  GetOrganizationUploadUrlResponse,
  GetUserUploadUrlData,
  GetUserUploadUrlResponse,
  FindCadencesData,
  FindCadencesResponse,
  CreateCadenceData,
  CreateCadenceResponse,
  ArchiveCadenceData,
  ArchiveCadenceResponse,
  UpdateCadenceData,
  UpdateCadenceResponse,
  UnarchiveCadenceData,
  UnarchiveCadenceResponse,
  FindTimeBoxesData,
  FindTimeBoxesResponse,
  CreateTimeBoxData,
  CreateTimeBoxResponse,
  UpdateTimeBoxData,
  UpdateTimeBoxResponse,
  DeleteTimeBoxData,
  DeleteTimeBoxResponse,
  FindBoardFoldersData,
  FindBoardFoldersResponse,
  CreateBoardFolderData,
  CreateBoardFolderResponse,
  ArchiveBoardFolderData,
  ArchiveBoardFolderResponse,
  GetBoardFolderByIdData,
  GetBoardFolderByIdResponse,
  UpdateBoardFolderData,
  UpdateBoardFolderResponse,
  UnarchiveBoardFolderData,
  UnarchiveBoardFolderResponse,
  FindBoardsData,
  FindBoardsResponse,
  CreateBoardData,
  CreateBoardResponse,
  ArchiveBoardData,
  ArchiveBoardResponse,
  GetBoardByIdData,
  GetBoardByIdResponse,
  UpdateBoardData,
  UpdateBoardResponse,
  FindFavoriteBoardsData,
  FindFavoriteBoardsResponse,
  UpdateFavoriteBoardsData,
  UpdateFavoriteBoardsResponse,
  GetBoardFoldersByIdsData,
  GetBoardFoldersByIdsResponse,
  GetBoardsByIdsData,
  GetBoardsByIdsResponse,
  FindBoardsByRangeData,
  FindBoardsByRangeResponse,
  RemoveCommentFavoriteData,
  RemoveCommentFavoriteResponse,
  AddCommentFavoriteData,
  AddCommentFavoriteResponse,
  AddCommentReactionData,
  AddCommentReactionResponse,
  FindCommentRepliesData,
  FindCommentRepliesResponse,
  AddCommentReplyData,
  AddCommentReplyResponse,
  FindItemCommentsData,
  FindItemCommentsResponse,
  AddItemCommentData,
  AddItemCommentResponse,
  DeleteCommentData,
  DeleteCommentResponse,
  GetCommentByIdData,
  GetCommentByIdResponse,
  UpdateCommentData,
  UpdateCommentResponse,
  RemoveCommentReactionData,
  RemoveCommentReactionResponse,
  GetCommentMessageHistoryByCommentIdData,
  GetCommentMessageHistoryByCommentIdResponse,
  FindGithubInstallationsByOrganizationIdData,
  FindGithubInstallationsByOrganizationIdResponse,
  CreateGithubInstallationData,
  CreateGithubInstallationResponse,
  GetWorkItemBranchesData,
  GetWorkItemBranchesResponse,
  GetWorkItemCommitsData,
  GetWorkItemCommitsResponse,
  GetWorkItemPullRequestsData,
  GetWorkItemPullRequestsResponse,
  FindImportJobsData,
  FindImportJobsResponse,
  CreateImportJobData,
  CreateImportJobResponse,
  FindImportJobRunsData,
  FindImportJobRunsResponse,
  CreateImportJobRunData,
  CreateImportJobRunResponse,
  GenerateExportFileData,
  GenerateExportFileResponse,
  GetImportUploadUrlData,
  GetImportUploadUrlResponse,
  SyncAdoWorkitemData,
  SyncAdoWorkitemResponse,
  FindIntegrationInstallationsData,
  FindIntegrationInstallationsResponse,
  CreateIntegrationInstallationData,
  CreateIntegrationInstallationResponse,
  CreateOAuthTokenData,
  SyncJiraSubitemData,
  SyncJiraSubitemResponse,
  SyncJiraWorkitemData,
  SyncJiraWorkitemResponse,
  ProxyInstallationRequestData,
  ProxyInstallationRequestResponse2,
  SaveProviderConfigurationData,
  SaveProviderConfigurationResponse,
  UpdateIntegrationCredentialData,
  UpdateIntegrationCredentialResponse,
  FindCredentialsAccountsData,
  FindCredentialsAccountsResponse,
  FindIntegrationCredentialsData,
  FindIntegrationCredentialsResponse,
  GetIntegrationAuthorizeUrlData,
  GetIntegrationAuthorizeUrlResponse,
  CreateFolderData,
  CreateFolderResponse,
  DeleteFolderData,
  DeleteFolderResponse,
  GetFolderByIdData,
  GetFolderByIdResponse,
  UpdateFolderData,
  UpdateFolderResponse,
  ArchiveFolderData,
  ArchiveFolderResponse,
  UnarchiveFolderData,
  UnarchiveFolderResponse,
  ArchiveFoldersData,
  ArchiveFoldersResponse,
  UpdateFolderRelationshipsData,
  UpdateFolderRelationshipsResponse,
  CreateWorkItemData,
  CreateWorkItemResponse,
  DeleteWorkItemData,
  DeleteWorkItemResponse,
  GetWorkItemByIdData,
  GetWorkItemByIdResponse,
  UpdateWorkItemData,
  UpdateWorkItemResponse,
  ArchiveWorkItemData,
  ArchiveWorkItemResponse,
  UnarchiveWorkItemData,
  UnarchiveWorkItemResponse,
  ArchiveWorkItemsData,
  ArchiveWorkItemsResponse,
  UpdateWorkItemRelationshipsData,
  UpdateWorkItemRelationshipsResponse,
  BulkUpdateItemsData,
  BulkUpdateItemsResponse,
  CopyWorkItemData,
  CopyWorkItemResponse,
  BroadcastWorkItemDraftData,
  BroadcastWorkItemDraftResponse2,
  CreateSubItemData,
  CreateSubItemResponse,
  DeleteSubItemData,
  DeleteSubItemResponse,
  UpdateSubItemData,
  UpdateSubItemResponse,
  GetFoldersByIdsData,
  GetFoldersByIdsResponse,
  GetWorkItemsByIdsData,
  GetWorkItemsByIdsResponse,
  FindItemsData,
  FindItemsResponse,
  GetItemHierarchyData,
  GetItemHierarchyResponse,
  GetPublicStoredViewItemsData,
  GetPublicStoredViewItemsResponse,
  SubmitBulkCreateItemsJobData,
  SubmitBulkCreateItemsJobResponse,
  SubmitCopyStreamJobData,
  SubmitCopyStreamJobResponse,
  SubmitCopyItemJobData,
  SubmitCopyItemJobResponse,
  SubmitShiftStartDueDateJobData,
  SubmitShiftStartDueDateJobResponse,
  SubmitUpdateItemsJobData,
  SubmitUpdateItemsJobResponse,
  SubmitUpdateFilteredItemsJobData,
  SubmitUpdateFilteredItemsJobResponse,
  SubmitCreateImportRunData,
  SubmitCreateImportRunResponse,
  SubmitDisableInstallationIntegrationJobData,
  SubmitDisableInstallationIntegrationJobResponse,
  SubmitIntegrationJobData,
  SubmitIntegrationJobResponse,
  SubmitDisableCredentialIntegrationJobData,
  SubmitDisableCredentialIntegrationJobResponse,
  FindJobsData,
  FindJobsResponse,
  GetJobByIdData,
  GetJobByIdResponse,
  ActivateReadOnlyAccessData,
  ActivateReadOnlyAccessResponse,
  AdminUpdateOrganizationData,
  AdminUpdateOrganizationResponse,
  DeleteReadOnlyCredentialsData,
  DeleteReadOnlyCredentialsResponse,
  GetReadOnlyCredentialsData,
  GetReadOnlyCredentialsResponse,
  GenerateReadOnlyCredentialsData,
  GenerateReadOnlyCredentialsResponse,
  RevokeReadOnlyAccessData,
  RevokeReadOnlyAccessResponse,
  RotateReadOnlyPasswordData,
  RotateReadOnlyPasswordResponse,
  SyncReadOnlyAccessData,
  SyncReadOnlyAccessResponse,
  CreateOrganizationData,
  CreateOrganizationResponse,
  GetOrganizationByIdData,
  GetOrganizationByIdResponse,
  UpdateOrganizationData,
  UpdateOrganizationResponse,
  CreateUserLabelGroupData,
  CreateUserLabelGroupResponse,
  DeleteUserLabelGroupData,
  DeleteUserLabelGroupResponse,
  UpdateUserLabelGroupData,
  UpdateUserLabelGroupResponse,
  AddCreateWorkTypeData,
  AddCreateWorkTypeResponse,
  ArchiveWorkTypeData,
  ArchiveWorkTypeResponse,
  UpdateWorkTypeData,
  UpdateWorkTypeResponse,
  FindItemRequestsData,
  FindItemRequestsResponse,
  AddItemRequestData,
  AddItemRequestResponse,
  DeleteItemRequestData,
  DeleteItemRequestResponse,
  UpdateItemRequestData,
  UpdateItemRequestResponse,
  FindStoredViewsData,
  FindStoredViewsResponse,
  CreateStoredViewData,
  CreateStoredViewResponse,
  DeleteStoredViewData,
  DeleteStoredViewResponse,
  UpdateStoredViewData,
  UpdateStoredViewResponse,
  FindBulkItemTemplatesData,
  FindBulkItemTemplatesResponse,
  CreateBulkItemTemplateData,
  CreateBulkItemTemplateResponse,
  DeleteBulkItemTemplateData,
  DeleteBulkItemTemplateResponse,
  UpdateBulkItemTemplateData,
  UpdateBulkItemTemplateResponse,
  FindDescriptionTemplatesData,
  FindDescriptionTemplatesResponse,
  CreateDescriptionTemplateData,
  CreateDescriptionTemplateResponse,
  DeleteDescriptionTemplateData,
  DeleteDescriptionTemplateResponse,
  UpdateDescriptionTemplateData,
  UpdateDescriptionTemplateResponse,
  FindItemRequestGroupsData,
  FindItemRequestGroupsResponse,
  CreateItemRequestGroupData,
  CreateItemRequestGroupResponse,
  DeleteItemRequestGroupData,
  DeleteItemRequestGroupResponse,
  UpdateItemRequestGroupData,
  UpdateItemRequestGroupResponse,
  SubmitPublicItemRequestData,
  SubmitPublicItemRequestResponse,
  SubmitItemRequestData,
  SubmitItemRequestResponse,
  CreateCustomFieldData,
  CreateCustomFieldResponse,
  CreateCustomFieldCollectionData,
  CreateCustomFieldCollectionResponse,
  FindCustomFieldFormGroupsData,
  FindCustomFieldFormGroupsResponse,
  CreateCustomFieldFormGroupData,
  CreateCustomFieldFormGroupResponse,
  CreateLabelCollectionData,
  CreateLabelCollectionResponse,
  CreateLabelData,
  CreateLabelResponse,
  CreateLaneCollectionData,
  CreateLaneCollectionResponse,
  CreateLaneData,
  CreateLaneResponse,
  CreateEstimateOptionCollectionData,
  CreateEstimateOptionCollectionResponse,
  CreateEstimateOptionData,
  CreateEstimateOptionResponse,
  CreatePriorityData,
  CreatePriorityResponse,
  CreatePriorityCollectionData,
  CreatePriorityCollectionResponse,
  DeleteCustomFieldData,
  DeleteCustomFieldResponse,
  UpdateCustomFieldData,
  UpdateCustomFieldResponse,
  DeleteCustomFieldFormGroupData,
  DeleteCustomFieldFormGroupResponse,
  UpdateCustomFieldFormGroupData,
  UpdateCustomFieldFormGroupResponse,
  DeleteCustomFieldCollectionData,
  DeleteCustomFieldCollectionResponse,
  UpdateCustomFieldCollectionData,
  UpdateCustomFieldCollectionResponse,
  DeleteEstimateOptionData,
  DeleteEstimateOptionResponse,
  UpdateEstimateOptionData,
  UpdateEstimateOptionResponse,
  DeleteEstimateOptionCollectionData,
  DeleteEstimateOptionCollectionResponse,
  UpdateEstimateOptionCollectionData,
  UpdateEstimateOptionCollectionResponse,
  DeleteLabelData,
  DeleteLabelResponse,
  UpdateLabelData,
  UpdateLabelResponse,
  DeleteLabelCollectionData,
  DeleteLabelCollectionResponse,
  UpdateLabelCollectionData,
  UpdateLabelCollectionResponse,
  DeleteLaneData,
  DeleteLaneResponse,
  UpdateLaneData,
  UpdateLaneResponse,
  DeleteLaneCollectionData,
  DeleteLaneCollectionResponse,
  UpdateLaneCollectionData,
  UpdateLaneCollectionResponse,
  DeletePriorityData,
  DeletePriorityResponse,
  UpdatePriorityData,
  UpdatePriorityResponse,
  DeletePriorityCollectionData,
  DeletePriorityCollectionResponse,
  UpdatePriorityCollectionData,
  UpdatePriorityCollectionResponse,
  FindOrganizationsData,
  FindOrganizationsResponse,
  CheckIfOrganizationExistsData,
  CheckIfOrganizationExistsResponse,
  FindOrganizationsByDomainData,
  FindOrganizationsByDomainResponse,
  GetItemRequestByIdData,
  GetItemRequestByIdResponse,
  GetPublicItemRequestByIdData,
  GetPublicItemRequestByIdResponse,
  GetPublicItemRequestUploadUrlData,
  GetPublicItemRequestUploadUrlResponse,
  GetPublicStoredViewByIdData,
  GetPublicStoredViewByIdResponse,
  GetConnectionDetailsData,
  GetConnectionDetailsResponse,
  GetPusherAuthData,
  GetPusherAuthResponse,
  GetPusherEventByIdData,
  GetPusherEventByIdResponse,
  FindRoadmapsData,
  FindRoadmapsResponse,
  CreateRoadmapData,
  CreateRoadmapResponse,
  DeleteRoadmapData,
  DeleteRoadmapResponse,
  GetRoadmapByIdData,
  GetRoadmapByIdResponse,
  UpdateRoadmapData,
  UpdateRoadmapResponse,
  CreateInitiativeData,
  CreateInitiativeResponse,
  DeleteInitiativeData,
  DeleteInitiativeResponse,
  UpdateInitiativeData,
  UpdateInitiativeResponse,
  CreateMilestoneData,
  CreateMilestoneResponse,
  DeleteMilestoneData,
  DeleteMilestoneResponse,
  UpdateMilestoneData,
  UpdateMilestoneResponse,
  CreateScenarioData,
  CreateScenarioResponse,
  DeleteScenarioData,
  DeleteScenarioResponse,
  UpdateScenarioData,
  UpdateScenarioResponse,
  FindRoadmapGroupsData,
  FindRoadmapGroupsResponse,
  CreateRoadmapGroupData,
  CreateRoadmapGroupResponse,
  DeleteRoadmapGroupData,
  DeleteRoadmapGroupResponse,
  UpdateRoadmapGroupData,
  UpdateRoadmapGroupResponse,
  UpdateRoadmapItemData,
  UpdateRoadmapItemResponse,
  DeleteSlackInstallationData,
  DeleteSlackInstallationResponse,
  InitiateSlackOAuthData,
  InitiateSlackOAuthResponse,
  SlackOAuthCallbackData,
  FindSlackInstallationsByOrganizationIdData,
  FindSlackInstallationsByOrganizationIdResponse,
  CheckIfPaymentMethodsExistsData,
  CheckIfPaymentMethodsExistsResponse,
  GetPaymentMethodsData,
  GetPaymentMethodsResponse,
  GetSubscriptionInvoicesData,
  GetSubscriptionInvoicesResponse,
  GetProductsData,
  GetProductsResponse,
  GetCustomerData,
  GetCustomerResponse,
  SetupPaymentMethodData,
  SetupPaymentMethodResponse2,
  SetDefaultPaymentMethodData,
  SetDefaultPaymentMethodResponse,
  DeletePaymentMethodData,
  DeletePaymentMethodResponse,
  CreateSubscriptionData,
  CreateSubscriptionResponse,
  UpdateSubscriptionData,
  UpdateSubscriptionResponse,
  CreateProductData,
  CreateProductResponse,
  UpdateProductData,
  UpdateProductResponse,
  FindTimeEntriesData,
  FindTimeEntriesResponse,
  CreateTimeEntryData,
  CreateTimeEntryResponse,
  DeleteTimeEntryData,
  DeleteTimeEntryResponse,
  UpdateTimeEntryData,
  UpdateTimeEntryResponse,
  GetActiveTimeEntryData,
  GetActiveTimeEntryResponse,
  FindWorkflowsData,
  FindWorkflowsResponse,
  CreateWorkflowData,
  CreateWorkflowResponse,
  FindWorkflowGroupsData,
  FindWorkflowGroupsResponse,
  CreateWorkflowGroupData,
  CreateWorkflowGroupResponse,
  FindWorkflowRunsData,
  FindWorkflowRunsResponse,
  DeleteWorkflowData,
  DeleteWorkflowResponse,
  UpdateWorkflowData,
  UpdateWorkflowResponse,
  DeleteWorkflowGroupData,
  DeleteWorkflowGroupResponse,
  UpdateWorkflowGroupData,
  UpdateWorkflowGroupResponse,
  CreateWebhookData,
  CreateWebhookResponse,
  TriggerWebhookWorkflowsData,
  TriggerWebhookWorkflowsResponse,
} from './types.gen';

export const client = createClient(
  createConfig({
    throwOnError: true,
  })
);

export class ActivityService {
  /**
   * Update Notification
   */
  public static updateNotification<ThrowOnError extends boolean = true>(
    options: Options<UpdateNotificationData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateNotificationResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/notifications/{notificationId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Notifications
   */
  public static findNotifications<ThrowOnError extends boolean = true>(
    options: Options<FindNotificationsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindNotificationsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/notifications',
      ...options,
    });
  }

  /**
   * Get Activity Log By Id
   */
  public static getActivityLogById<ThrowOnError extends boolean = true>(
    options: Options<GetActivityLogByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetActivityLogByIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/activity-logs/log/{activityLogId}',
      ...options,
    });
  }

  /**
   * Find Activity Logs
   */
  public static findActivityLogs<ThrowOnError extends boolean = true>(
    options: Options<FindActivityLogsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindActivityLogsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/activity-logs/{referenceId}',
      ...options,
    });
  }
}

export class AiService {
  /**
   * Create Chat Message
   */
  public static createChatMessage<ThrowOnError extends boolean = true>(
    options: Options<CreateChatMessageData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateChatMessageResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/ai/chats/{chatId}/messages',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Chat
   */
  public static createChat<ThrowOnError extends boolean = true>(
    options: Options<CreateChatData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateChatResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/ai/chats',
      ...options,
    });
  }

  /**
   * Generate Item Description
   */
  public static generateItemDescription<ThrowOnError extends boolean = true>(
    options: Options<GenerateItemDescriptionData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      GenerateItemDescriptionResponse2,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/ai/generate-item-description',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Proxy AI Request
   */
  public static proxyAiRequest<ThrowOnError extends boolean = true>(
    options: Options<ProxyAiRequestData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ProxyAiRequestResponse2,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/ai/proxy',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }
}

export class AnalyticsService {
  /**
   * Create Export Items Job
   */
  public static createExportItemsJob<ThrowOnError extends boolean = true>(
    options: Options<CreateExportItemsJobData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateExportItemsJobResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/analytics/exports/items',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Export Job
   */
  public static deleteExportJob<ThrowOnError extends boolean = true>(
    options: Options<DeleteExportJobData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteExportJobResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/analytics/exports/items/{exportJobId}',
      ...options,
    });
  }

  /**
   * Get Export Job By Id
   */
  public static getExportJobById<ThrowOnError extends boolean = true>(
    options: Options<GetExportJobByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetExportJobByIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/analytics/exports/items/{exportJobId}',
      ...options,
    });
  }

  /**
   * Find Export Jobs
   */
  public static findExportJobs<ThrowOnError extends boolean = true>(
    options: Options<FindExportJobsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindExportJobsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/analytics/exports',
      ...options,
    });
  }

  /**
   * Get Cube AuthToken
   */
  public static getCubeAuthToken<ThrowOnError extends boolean = true>(
    options: Options<GetCubeAuthTokenData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetCubeAuthTokenResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/analytics/cube-auth',
      ...options,
    });
  }

  /**
   * Get Report By Export Job Id
   */
  public static getReportByExportJobId<ThrowOnError extends boolean = true>(
    options: Options<GetReportByExportJobIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetReportByExportJobIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/analytics/exports/items/{exportJobId}/download',
      ...options,
    });
  }
}

export class AssetsService {
  /**
   * Create Asset Group
   */
  public static createAssetGroup<ThrowOnError extends boolean = true>(
    options: Options<CreateAssetGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateAssetGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/asset-groups',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Asset Item
   */
  public static createAssetItem<ThrowOnError extends boolean = true>(
    options: Options<CreateAssetItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateAssetItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/asset-items',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Asset Group
   */
  public static deleteAssetGroup<ThrowOnError extends boolean = true>(
    options: Options<DeleteAssetGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteAssetGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/asset-groups/{assetGroupId}',
      ...options,
    });
  }

  /**
   * Update Asset Group
   */
  public static updateAssetGroup<ThrowOnError extends boolean = true>(
    options: Options<UpdateAssetGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateAssetGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/asset-groups/{assetGroupId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Asset Item
   */
  public static deleteAssetItem<ThrowOnError extends boolean = true>(
    options: Options<DeleteAssetItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteAssetItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/asset-items/{assetItemId}',
      ...options,
    });
  }

  /**
   * Update Asset Item
   */
  public static updateAssetItem<ThrowOnError extends boolean = true>(
    options: Options<UpdateAssetItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateAssetItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/asset-items/{assetItemId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Item Assets
   */
  public static findItemAssets<ThrowOnError extends boolean = true>(
    options: Options<FindItemAssetsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindItemAssetsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/assets',
      ...options,
    });
  }

  /**
   * Get Asset Download URL
   */
  public static getAssetDownloadUrl<ThrowOnError extends boolean = true>(
    options: Options<GetAssetDownloadUrlData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetAssetDownloadUrlResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/items/{itemNumber}/assets/{assetItemId}/download-url',
      ...options,
    });
  }

  /**
   * Get Organization Upload Url
   */
  public static getOrganizationUploadUrl<ThrowOnError extends boolean = true>(
    options: Options<GetOrganizationUploadUrlData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetOrganizationUploadUrlResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/assets/upload-url',
      ...options,
    });
  }

  /**
   * Get User Upload Url
   */
  public static getUserUploadUrl<ThrowOnError extends boolean = true>(
    options: Options<GetUserUploadUrlData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetUserUploadUrlResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/assets/user-upload-url',
      ...options,
    });
  }
}

export class BoardService {
  /**
   * Find Cadences
   */
  public static findCadences<ThrowOnError extends boolean = true>(
    options: Options<FindCadencesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindCadencesResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/cadences',
      ...options,
    });
  }

  /**
   * Create Cadence
   */
  public static createCadence<ThrowOnError extends boolean = true>(
    options: Options<CreateCadenceData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateCadenceResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/cadences',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Archive Cadence
   */
  public static archiveCadence<ThrowOnError extends boolean = true>(
    options: Options<ArchiveCadenceData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ArchiveCadenceResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/cadences/{cadenceId}',
      ...options,
    });
  }

  /**
   * Update Cadence
   */
  public static updateCadence<ThrowOnError extends boolean = true>(
    options: Options<UpdateCadenceData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateCadenceResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/cadences/{cadenceId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Unarchive Cadence
   */
  public static unarchiveCadence<ThrowOnError extends boolean = true>(
    options: Options<UnarchiveCadenceData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UnarchiveCadenceResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/cadences/{cadenceId}/unarchive',
      ...options,
    });
  }

  /**
   * Find TimeBoxes
   */
  public static findTimeBoxes<ThrowOnError extends boolean = true>(
    options: Options<FindTimeBoxesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindTimeBoxesResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/time-boxes',
      ...options,
    });
  }

  /**
   * Create TimeBox
   */
  public static createTimeBox<ThrowOnError extends boolean = true>(
    options: Options<CreateTimeBoxData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateTimeBoxResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/time-boxes',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Update TimeBox
   */
  public static updateTimeBox<ThrowOnError extends boolean = true>(
    options: Options<UpdateTimeBoxData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateTimeBoxResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/time-boxes/{timeBoxId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete TimeBox
   */
  public static deleteTimeBox<ThrowOnError extends boolean = true>(
    options: Options<DeleteTimeBoxData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteTimeBoxResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/cadences/{cadenceId}/time-boxes/{timeBoxId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find BoardFolders
   */
  public static findBoardFolders<ThrowOnError extends boolean = true>(
    options: Options<FindBoardFoldersData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindBoardFoldersResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/board-folders',
      ...options,
    });
  }

  /**
   * Create BoardFolder
   */
  public static createBoardFolder<ThrowOnError extends boolean = true>(
    options: Options<CreateBoardFolderData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateBoardFolderResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/board-folders',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Archive BoardFolder
   */
  public static archiveBoardFolder<ThrowOnError extends boolean = true>(
    options: Options<ArchiveBoardFolderData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ArchiveBoardFolderResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/board-folders/{boardFolderId}',
      ...options,
    });
  }

  /**
   * Get Board Folder By Id
   */
  public static getBoardFolderById<ThrowOnError extends boolean = true>(
    options: Options<GetBoardFolderByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetBoardFolderByIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/board-folders/{boardFolderId}',
      ...options,
    });
  }

  /**
   * Update BoardFolder
   */
  public static updateBoardFolder<ThrowOnError extends boolean = true>(
    options: Options<UpdateBoardFolderData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateBoardFolderResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/board-folders/{boardFolderId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Unarchive BoardFolder
   */
  public static unarchiveBoardFolder<ThrowOnError extends boolean = true>(
    options: Options<UnarchiveBoardFolderData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UnarchiveBoardFolderResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/board-folders/{boardFolderId}/unarchive',
      ...options,
    });
  }

  /**
   * Find Boards
   */
  public static findBoards<ThrowOnError extends boolean = true>(
    options: Options<FindBoardsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindBoardsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/boards',
      ...options,
    });
  }

  /**
   * Create Board
   */
  public static createBoard<ThrowOnError extends boolean = true>(
    options: Options<CreateBoardData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateBoardResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/boards',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Archive Board
   */
  public static archiveBoard<ThrowOnError extends boolean = true>(
    options: Options<ArchiveBoardData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ArchiveBoardResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/boards/{boardId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Get Board By Id
   */
  public static getBoardById<ThrowOnError extends boolean = true>(
    options: Options<GetBoardByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetBoardByIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/boards/{boardId}',
      ...options,
    });
  }

  /**
   * Update Board
   */
  public static updateBoard<ThrowOnError extends boolean = true>(
    options: Options<UpdateBoardData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateBoardResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/boards/{boardId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Favorite Boards
   */
  public static findFavoriteBoards<ThrowOnError extends boolean = true>(
    options: Options<FindFavoriteBoardsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindFavoriteBoardsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/board-favorites',
      ...options,
    });
  }

  /**
   * Update Favorite Boards
   */
  public static updateFavoriteBoards<ThrowOnError extends boolean = true>(
    options: Options<UpdateFavoriteBoardsData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateFavoriteBoardsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/board-favorites',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Get Board Folders By Ids
   */
  public static getBoardFoldersByIds<ThrowOnError extends boolean = true>(
    options: Options<GetBoardFoldersByIdsData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      GetBoardFoldersByIdsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/board-folders/batch',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Get Boards By Ids
   */
  public static getBoardsByIds<ThrowOnError extends boolean = true>(
    options: Options<GetBoardsByIdsData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      GetBoardsByIdsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/boards/batch',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Boards By Range
   */
  public static findBoardsByRange<ThrowOnError extends boolean = true>(
    options: Options<FindBoardsByRangeData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindBoardsByRangeResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/boards-by-range',
      ...options,
    });
  }
}

export class CommentService {
  /**
   * Remove Comment Favorite
   */
  public static removeCommentFavorite<ThrowOnError extends boolean = true>(
    options: Options<RemoveCommentFavoriteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      RemoveCommentFavoriteResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-comments/{commentId}/favorite',
      ...options,
    });
  }

  /**
   * Add Comment Favorite
   */
  public static addCommentFavorite<ThrowOnError extends boolean = true>(
    options: Options<AddCommentFavoriteData, ThrowOnError>
  ) {
    return (options?.client ?? client).put<
      AddCommentFavoriteResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-comments/{commentId}/favorite',
      ...options,
    });
  }

  /**
   * Add Comment Reaction
   */
  public static addCommentReaction<ThrowOnError extends boolean = true>(
    options: Options<AddCommentReactionData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AddCommentReactionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-comments/{commentId}/reactions',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Comment Replies
   */
  public static findCommentReplies<ThrowOnError extends boolean = true>(
    options: Options<FindCommentRepliesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindCommentRepliesResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-comments/{commentId}/replies',
      ...options,
    });
  }

  /**
   * Add Comment Reply
   */
  public static addCommentReply<ThrowOnError extends boolean = true>(
    options: Options<AddCommentReplyData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AddCommentReplyResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-comments/{commentId}/replies',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Item Comments
   */
  public static findItemComments<ThrowOnError extends boolean = true>(
    options: Options<FindItemCommentsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindItemCommentsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-comments',
      ...options,
    });
  }

  /**
   * Add Item Comment
   */
  public static addItemComment<ThrowOnError extends boolean = true>(
    options: Options<AddItemCommentData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AddItemCommentResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-comments',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Comment
   */
  public static deleteComment<ThrowOnError extends boolean = true>(
    options: Options<DeleteCommentData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteCommentResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-comments/{commentId}',
      ...options,
    });
  }

  /**
   * Get Comment
   */
  public static getCommentById<ThrowOnError extends boolean = true>(
    options: Options<GetCommentByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetCommentByIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-comments/{commentId}',
      ...options,
    });
  }

  /**
   * Update Comment
   */
  public static updateComment<ThrowOnError extends boolean = true>(
    options: Options<UpdateCommentData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateCommentResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-comments/{commentId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Remove Comment Reaction
   */
  public static removeCommentReaction<ThrowOnError extends boolean = true>(
    options: Options<RemoveCommentReactionData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      RemoveCommentReactionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-comments/{commentId}/reactions/{reaction}',
      ...options,
    });
  }

  /**
   * Get Comment Message History
   */
  public static getCommentMessageHistoryByCommentId<
    ThrowOnError extends boolean = true
  >(options: Options<GetCommentMessageHistoryByCommentIdData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetCommentMessageHistoryByCommentIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-comments/{commentId}/history',
      ...options,
    });
  }
}

export class GithubIntegrationService {
  /**
   * Find Github Installations By OrganizationId
   */
  public static findGithubInstallationsByOrganizationId<
    ThrowOnError extends boolean = true
  >(
    options: Options<FindGithubInstallationsByOrganizationIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindGithubInstallationsByOrganizationIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/integrations/github/{organizationId}',
      ...options,
    });
  }

  /**
   * Create Github Installation
   */
  public static createGithubInstallation<ThrowOnError extends boolean = true>(
    options: Options<CreateGithubInstallationData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateGithubInstallationResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/integrations/github/{organizationId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Get WorkItem Branches
   */
  public static getWorkItemBranches<ThrowOnError extends boolean = true>(
    options: Options<GetWorkItemBranchesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetWorkItemBranchesResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/integrations/github/{organizationId}/work-items/{itemNumber}/branches',
      ...options,
    });
  }

  /**
   * Get WorkItem Commits
   */
  public static getWorkItemCommits<ThrowOnError extends boolean = true>(
    options: Options<GetWorkItemCommitsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetWorkItemCommitsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/integrations/github/{organizationId}/work-items/{itemNumber}/commits',
      ...options,
    });
  }

  /**
   * Get WorkItem Pull Requests
   */
  public static getWorkItemPullRequests<ThrowOnError extends boolean = true>(
    options: Options<GetWorkItemPullRequestsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetWorkItemPullRequestsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/integrations/github/{organizationId}/work-items/{itemNumber}/pull-requests',
      ...options,
    });
  }
}

export class ImporterService {
  /**
   * Find Import Jobs
   */
  public static findImportJobs<ThrowOnError extends boolean = true>(
    options: Options<FindImportJobsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindImportJobsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/importer/jobs',
      ...options,
    });
  }

  /**
   * Create Import Job
   */
  public static createImportJob<ThrowOnError extends boolean = true>(
    options: Options<CreateImportJobData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateImportJobResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/importer/jobs',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Import Job Runs
   */
  public static findImportJobRuns<ThrowOnError extends boolean = true>(
    options: Options<FindImportJobRunsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindImportJobRunsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/importer/jobs/{importJobId}/runs',
      ...options,
    });
  }

  /**
   * Create Import Job Run
   */
  public static createImportJobRun<ThrowOnError extends boolean = true>(
    options: Options<CreateImportJobRunData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateImportJobRunResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/importer/jobs/{importJobId}/runs',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Generate Export File
   */
  public static generateExportFile<ThrowOnError extends boolean = true>(
    options: Options<GenerateExportFileData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      GenerateExportFileResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/importer/generate-export-file',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Get pre-signed upload URL for import job
   */
  public static getImportUploadUrl<ThrowOnError extends boolean = true>(
    options: Options<GetImportUploadUrlData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetImportUploadUrlResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/importer/upload-url',
      ...options,
    });
  }
}

export class IntegrationService {
  /**
   * Sync ADO Workitem
   */
  public static syncAdoWorkitem<ThrowOnError extends boolean = true>(
    options: Options<SyncAdoWorkitemData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      SyncAdoWorkitemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/integrations/{installationId}/ado/sync-workitem',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Integration Installations
   */
  public static findIntegrationInstallations<
    ThrowOnError extends boolean = true
  >(options: Options<FindIntegrationInstallationsData, ThrowOnError>) {
    return (options?.client ?? client).get<
      FindIntegrationInstallationsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/integrations/installations',
      ...options,
    });
  }

  /**
   * Create Integration Installation
   */
  public static createIntegrationInstallation<
    ThrowOnError extends boolean = true
  >(options: Options<CreateIntegrationInstallationData, ThrowOnError>) {
    return (options?.client ?? client).post<
      CreateIntegrationInstallationResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/integrations/installations',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * OAuth2 Callback Handler
   */
  public static createOAuthToken<ThrowOnError extends boolean = true>(
    options: Options<CreateOAuthTokenData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
      url: '/v1/integrations/oauth2/callback',
      ...options,
    });
  }

  /**
   * Sync Jira Subitem
   */
  public static syncJiraSubitem<ThrowOnError extends boolean = true>(
    options: Options<SyncJiraSubitemData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      SyncJiraSubitemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/integrations/{installationId}/jira/sync-subitem',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Sync Jira Workitem
   */
  public static syncJiraWorkitem<ThrowOnError extends boolean = true>(
    options: Options<SyncJiraWorkitemData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      SyncJiraWorkitemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/integrations/{installationId}/jira/sync-workitem',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Proxy Installation Request
   */
  public static proxyInstallationRequest<ThrowOnError extends boolean = true>(
    options: Options<ProxyInstallationRequestData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ProxyInstallationRequestResponse2,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/integrations/{installationId}/proxy',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Save Provider Configuration
   */
  public static saveProviderConfiguration<ThrowOnError extends boolean = true>(
    options: Options<SaveProviderConfigurationData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SaveProviderConfigurationResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/integrations/{installationId}/config',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Update Integration Credential
   */
  public static updateIntegrationCredential<
    ThrowOnError extends boolean = true
  >(options: Options<UpdateIntegrationCredentialData, ThrowOnError>) {
    return (options?.client ?? client).patch<
      UpdateIntegrationCredentialResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/integrations/credentials/{credentialsId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Credentials Accounts
   */
  public static findCredentialsAccounts<ThrowOnError extends boolean = true>(
    options: Options<FindCredentialsAccountsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindCredentialsAccountsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/integrations/credentials/{credentialsId}/accounts',
      ...options,
    });
  }

  /**
   * Find Integration Credentials
   */
  public static findIntegrationCredentials<ThrowOnError extends boolean = true>(
    options: Options<FindIntegrationCredentialsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindIntegrationCredentialsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/integrations/credentials',
      ...options,
    });
  }

  /**
   * Get Integration Authorize URL
   */
  public static getIntegrationAuthorizeUrl<ThrowOnError extends boolean = true>(
    options: Options<GetIntegrationAuthorizeUrlData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetIntegrationAuthorizeUrlResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/integrations/{provider}/authorize',
      ...options,
    });
  }
}

export class ItemService {
  /**
   * Create Folder
   */
  public static createFolder<ThrowOnError extends boolean = true>(
    options: Options<CreateFolderData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateFolderResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/folders',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Folder
   */
  public static deleteFolder<ThrowOnError extends boolean = true>(
    options: Options<DeleteFolderData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteFolderResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/folders/{itemNumber}',
      ...options,
    });
  }

  /**
   * Get Folder By Id
   */
  public static getFolderById<ThrowOnError extends boolean = true>(
    options: Options<GetFolderByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetFolderByIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/folders/{itemNumber}',
      ...options,
    });
  }

  /**
   * Update Folder
   */
  public static updateFolder<ThrowOnError extends boolean = true>(
    options: Options<UpdateFolderData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateFolderResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/folders/{itemNumber}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Archive Folder
   */
  public static archiveFolder<ThrowOnError extends boolean = true>(
    options: Options<ArchiveFolderData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      ArchiveFolderResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/folders/{itemNumber}/archive',
      ...options,
    });
  }

  /**
   * Unarchive Folder
   */
  public static unarchiveFolder<ThrowOnError extends boolean = true>(
    options: Options<UnarchiveFolderData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UnarchiveFolderResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/folders/{itemNumber}/unarchive',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Archive Folders
   */
  public static archiveFolders<ThrowOnError extends boolean = true>(
    options: Options<ArchiveFoldersData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      ArchiveFoldersResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/folders/archive',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Update Folder Relationships
   */
  public static updateFolderRelationships<ThrowOnError extends boolean = true>(
    options: Options<UpdateFolderRelationshipsData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateFolderRelationshipsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/folders/{itemNumber}/relationships',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create WorkItem
   */
  public static createWorkItem<ThrowOnError extends boolean = true>(
    options: Options<CreateWorkItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateWorkItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete WorkItem
   */
  public static deleteWorkItem<ThrowOnError extends boolean = true>(
    options: Options<DeleteWorkItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteWorkItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/{itemNumber}',
      ...options,
    });
  }

  /**
   * Get WorkItem By Id
   */
  public static getWorkItemById<ThrowOnError extends boolean = true>(
    options: Options<GetWorkItemByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetWorkItemByIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/{itemNumber}',
      ...options,
    });
  }

  /**
   * Update WorkItem
   */
  public static updateWorkItem<ThrowOnError extends boolean = true>(
    options: Options<UpdateWorkItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateWorkItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/{itemNumber}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Archive WorkItem
   */
  public static archiveWorkItem<ThrowOnError extends boolean = true>(
    options: Options<ArchiveWorkItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      ArchiveWorkItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/archive',
      ...options,
    });
  }

  /**
   * Unarchive WorkItem
   */
  public static unarchiveWorkItem<ThrowOnError extends boolean = true>(
    options: Options<UnarchiveWorkItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UnarchiveWorkItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/unarchive',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Archive WorkItems
   */
  public static archiveWorkItems<ThrowOnError extends boolean = true>(
    options: Options<ArchiveWorkItemsData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      ArchiveWorkItemsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/archive',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Update WorkItem Relationships
   */
  public static updateWorkItemRelationships<
    ThrowOnError extends boolean = true
  >(options: Options<UpdateWorkItemRelationshipsData, ThrowOnError>) {
    return (options?.client ?? client).patch<
      UpdateWorkItemRelationshipsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/relationships',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Bulk Update Items
   */
  public static bulkUpdateItems<ThrowOnError extends boolean = true>(
    options: Options<BulkUpdateItemsData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      BulkUpdateItemsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/items/bulk',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Copy WorkItem
   */
  public static copyWorkItem<ThrowOnError extends boolean = true>(
    options: Options<CopyWorkItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CopyWorkItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/copy',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Broadcast WorkItem description draft
   * Broadcasts a draft of the description to other users via Pusher for real-time collaboration. Does not persist to database.
   */
  public static broadcastWorkItemDraft<ThrowOnError extends boolean = true>(
    options: Options<BroadcastWorkItemDraftData, ThrowOnError>
  ) {
    return (options?.client ?? client).put<
      BroadcastWorkItemDraftResponse2,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/draft',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create SubItem
   */
  public static createSubItem<ThrowOnError extends boolean = true>(
    options: Options<CreateSubItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateSubItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/sub-items',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete SubItem
   */
  public static deleteSubItem<ThrowOnError extends boolean = true>(
    options: Options<DeleteSubItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteSubItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/sub-items/{subItemId}',
      ...options,
    });
  }

  /**
   * Update SubItem
   */
  public static updateSubItem<ThrowOnError extends boolean = true>(
    options: Options<UpdateSubItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateSubItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/sub-items/{subItemId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Get Folders By Ids
   */
  public static getFoldersByIds<ThrowOnError extends boolean = true>(
    options: Options<GetFoldersByIdsData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      GetFoldersByIdsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/folders/batch',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Get Work Items By Ids
   */
  public static getWorkItemsByIds<ThrowOnError extends boolean = true>(
    options: Options<GetWorkItemsByIdsData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      GetWorkItemsByIdsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-items/batch',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Items
   */
  public static findItems<ThrowOnError extends boolean = true>(
    options: Options<FindItemsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindItemsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/items',
      ...options,
    });
  }

  /**
   * Get Item Hierarchy
   */
  public static getItemHierarchy<ThrowOnError extends boolean = true>(
    options: Options<GetItemHierarchyData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetItemHierarchyResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/items/{itemNumber}/hierarchy',
      ...options,
    });
  }

  /**
   * Get Public Stored View Items
   */
  public static getPublicStoredViewItems<ThrowOnError extends boolean = true>(
    options: Options<GetPublicStoredViewItemsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetPublicStoredViewItemsResponse,
      unknown,
      ThrowOnError
    >({
      url: '/v1/organizations/{organizationId}/stored-views/public/{storedViewId}/items',
      ...options,
    });
  }
}

export class JobsService {
  /**
   * Submit Bulk Create Items Job
   */
  public static submitBulkCreateItemsJob<ThrowOnError extends boolean = true>(
    options: Options<SubmitBulkCreateItemsJobData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SubmitBulkCreateItemsJobResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/jobs/bulk-create-items',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Submit Copy Stream Job
   */
  public static submitCopyStreamJob<ThrowOnError extends boolean = true>(
    options: Options<SubmitCopyStreamJobData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SubmitCopyStreamJobResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/jobs/copy-stream',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Submit Copy Item Job
   */
  public static submitCopyItemJob<ThrowOnError extends boolean = true>(
    options: Options<SubmitCopyItemJobData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SubmitCopyItemJobResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/jobs/copy-item',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Submit Shift Start Due Date Job
   */
  public static submitShiftStartDueDateJob<ThrowOnError extends boolean = true>(
    options: Options<SubmitShiftStartDueDateJobData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SubmitShiftStartDueDateJobResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/jobs/shift-start-due-date',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Submit Update Items Job
   */
  public static submitUpdateItemsJob<ThrowOnError extends boolean = true>(
    options: Options<SubmitUpdateItemsJobData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SubmitUpdateItemsJobResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/jobs/update-items',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Submit Update Filtered Items Job
   */
  public static submitUpdateFilteredItemsJob<
    ThrowOnError extends boolean = true
  >(options: Options<SubmitUpdateFilteredItemsJobData, ThrowOnError>) {
    return (options?.client ?? client).post<
      SubmitUpdateFilteredItemsJobResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/jobs/update-filtered-items',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Submit Create Import Run
   */
  public static submitCreateImportRun<ThrowOnError extends boolean = true>(
    options: Options<SubmitCreateImportRunData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SubmitCreateImportRunResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/jobs/create-import-run',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Submit Disable Installation Integration Job
   */
  public static submitDisableInstallationIntegrationJob<
    ThrowOnError extends boolean = true
  >(
    options: Options<SubmitDisableInstallationIntegrationJobData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SubmitDisableInstallationIntegrationJobResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/jobs/disable-installation',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Submit Integration Job
   */
  public static submitIntegrationJob<ThrowOnError extends boolean = true>(
    options: Options<SubmitIntegrationJobData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SubmitIntegrationJobResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/jobs/integration',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Submit Disable Credential Integration Job
   */
  public static submitDisableCredentialIntegrationJob<
    ThrowOnError extends boolean = true
  >(options: Options<SubmitDisableCredentialIntegrationJobData, ThrowOnError>) {
    return (options?.client ?? client).post<
      SubmitDisableCredentialIntegrationJobResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/jobs/disable-credential',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Jobs
   */
  public static findJobs<ThrowOnError extends boolean = true>(
    options: Options<FindJobsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindJobsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/jobs',
      ...options,
    });
  }

  /**
   * Get Job By Id
   */
  public static getJobById<ThrowOnError extends boolean = true>(
    options: Options<GetJobByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetJobByIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/jobs/{jobId}',
      ...options,
    });
  }
}

export class OrganizationService {
  /**
   * Activate Read-Only Database Access
   */
  public static activateReadOnlyAccess<ThrowOnError extends boolean = true>(
    options: Options<ActivateReadOnlyAccessData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ActivateReadOnlyAccessResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/database-credentials/activate',
      ...options,
    });
  }

  /**
   * Admin Update Organization
   */
  public static adminUpdateOrganization<ThrowOnError extends boolean = true>(
    options: Options<AdminUpdateOrganizationData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      AdminUpdateOrganizationResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/admin/organizations/{organizationId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Read-Only Credentials
   */
  public static deleteReadOnlyCredentials<ThrowOnError extends boolean = true>(
    options: Options<DeleteReadOnlyCredentialsData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteReadOnlyCredentialsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/database-credentials',
      ...options,
    });
  }

  /**
   * Get Read-Only Database Credentials
   */
  public static getReadOnlyCredentials<ThrowOnError extends boolean = true>(
    options: Options<GetReadOnlyCredentialsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetReadOnlyCredentialsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/database-credentials',
      ...options,
    });
  }

  /**
   * Generate Read-Only Database Credentials
   */
  public static generateReadOnlyCredentials<
    ThrowOnError extends boolean = true
  >(options: Options<GenerateReadOnlyCredentialsData, ThrowOnError>) {
    return (options?.client ?? client).post<
      GenerateReadOnlyCredentialsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/database-credentials/generate',
      ...options,
    });
  }

  /**
   * Revoke Read-Only Database Access
   */
  public static revokeReadOnlyAccess<ThrowOnError extends boolean = true>(
    options: Options<RevokeReadOnlyAccessData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      RevokeReadOnlyAccessResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/database-credentials/revoke',
      ...options,
    });
  }

  /**
   * Rotate Read-Only Database Password
   */
  public static rotateReadOnlyPassword<ThrowOnError extends boolean = true>(
    options: Options<RotateReadOnlyPasswordData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      RotateReadOnlyPasswordResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/database-credentials/rotate-password',
      ...options,
    });
  }

  /**
   * Sync Read-Only Database Access
   */
  public static syncReadOnlyAccess<ThrowOnError extends boolean = true>(
    options: Options<SyncReadOnlyAccessData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SyncReadOnlyAccessResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/database-credentials/sync',
      ...options,
    });
  }

  /**
   * Create Organization
   */
  public static createOrganization<ThrowOnError extends boolean = true>(
    options?: Options<CreateOrganizationData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateOrganizationResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Get Organization By Id
   */
  public static getOrganizationById<ThrowOnError extends boolean = true>(
    options: Options<GetOrganizationByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetOrganizationByIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}',
      ...options,
    });
  }

  /**
   * Update Organization
   */
  public static updateOrganization<ThrowOnError extends boolean = true>(
    options: Options<UpdateOrganizationData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateOrganizationResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create User Label Group
   */
  public static createUserLabelGroup<ThrowOnError extends boolean = true>(
    options: Options<CreateUserLabelGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateUserLabelGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/user-label-groups',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete User Label Group
   */
  public static deleteUserLabelGroup<ThrowOnError extends boolean = true>(
    options: Options<DeleteUserLabelGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteUserLabelGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/user-label-groups/{userLabelGroupId}',
      ...options,
    });
  }

  /**
   * Update User Label Group
   */
  public static updateUserLabelGroup<ThrowOnError extends boolean = true>(
    options: Options<UpdateUserLabelGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateUserLabelGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/user-label-groups/{userLabelGroupId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Add WorkType
   */
  public static addCreateWorkType<ThrowOnError extends boolean = true>(
    options: Options<AddCreateWorkTypeData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AddCreateWorkTypeResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-types',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Archive Work Type
   */
  public static archiveWorkType<ThrowOnError extends boolean = true>(
    options: Options<ArchiveWorkTypeData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ArchiveWorkTypeResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-types/{workTypeId}',
      ...options,
    });
  }

  /**
   * Update WorkType
   */
  public static updateWorkType<ThrowOnError extends boolean = true>(
    options: Options<UpdateWorkTypeData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateWorkTypeResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/work-types/{workTypeId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Item Requests
   */
  public static findItemRequests<ThrowOnError extends boolean = true>(
    options: Options<FindItemRequestsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindItemRequestsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-requests',
      ...options,
    });
  }

  /**
   * Add Item Request
   */
  public static addItemRequest<ThrowOnError extends boolean = true>(
    options: Options<AddItemRequestData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AddItemRequestResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-requests',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Item Request
   */
  public static deleteItemRequest<ThrowOnError extends boolean = true>(
    options: Options<DeleteItemRequestData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteItemRequestResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-requests/{itemRequestId}',
      ...options,
    });
  }

  /**
   * Update Item Request
   */
  public static updateItemRequest<ThrowOnError extends boolean = true>(
    options: Options<UpdateItemRequestData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateItemRequestResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-requests/{itemRequestId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Stored Views
   */
  public static findStoredViews<ThrowOnError extends boolean = true>(
    options: Options<FindStoredViewsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindStoredViewsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/stored-views',
      ...options,
    });
  }

  /**
   * Create Stored View
   */
  public static createStoredView<ThrowOnError extends boolean = true>(
    options: Options<CreateStoredViewData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateStoredViewResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/stored-views',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Stored View
   */
  public static deleteStoredView<ThrowOnError extends boolean = true>(
    options: Options<DeleteStoredViewData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteStoredViewResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/stored-views/{storedViewId}',
      ...options,
    });
  }

  /**
   * Update Stored View
   */
  public static updateStoredView<ThrowOnError extends boolean = true>(
    options: Options<UpdateStoredViewData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateStoredViewResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/stored-views/{storedViewId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Bulk Item Templates
   */
  public static findBulkItemTemplates<ThrowOnError extends boolean = true>(
    options: Options<FindBulkItemTemplatesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindBulkItemTemplatesResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/bulk-item-templates',
      ...options,
    });
  }

  /**
   * Create Bulk Item Template
   */
  public static createBulkItemTemplate<ThrowOnError extends boolean = true>(
    options: Options<CreateBulkItemTemplateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateBulkItemTemplateResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/bulk-item-templates',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Bulk Item Template
   */
  public static deleteBulkItemTemplate<ThrowOnError extends boolean = true>(
    options: Options<DeleteBulkItemTemplateData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteBulkItemTemplateResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/bulk-item-templates/{bulkItemTemplateId}',
      ...options,
    });
  }

  /**
   * Update Bulk Item Template
   */
  public static updateBulkItemTemplate<ThrowOnError extends boolean = true>(
    options: Options<UpdateBulkItemTemplateData, ThrowOnError>
  ) {
    return (options?.client ?? client).put<
      UpdateBulkItemTemplateResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/bulk-item-templates/{bulkItemTemplateId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Description Templates
   */
  public static findDescriptionTemplates<ThrowOnError extends boolean = true>(
    options: Options<FindDescriptionTemplatesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindDescriptionTemplatesResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/description-templates',
      ...options,
    });
  }

  /**
   * Create Description Template
   */
  public static createDescriptionTemplate<ThrowOnError extends boolean = true>(
    options: Options<CreateDescriptionTemplateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateDescriptionTemplateResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/description-templates',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Description Template
   */
  public static deleteDescriptionTemplate<ThrowOnError extends boolean = true>(
    options: Options<DeleteDescriptionTemplateData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteDescriptionTemplateResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/description-templates/{descriptionTemplateId}',
      ...options,
    });
  }

  /**
   * Update Description Template
   */
  public static updateDescriptionTemplate<ThrowOnError extends boolean = true>(
    options: Options<UpdateDescriptionTemplateData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateDescriptionTemplateResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/description-templates/{descriptionTemplateId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Item Request Group Replies
   */
  public static findItemRequestGroups<ThrowOnError extends boolean = true>(
    options: Options<FindItemRequestGroupsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindItemRequestGroupsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-request-groups',
      ...options,
    });
  }

  /**
   * Create Item Request Group
   */
  public static createItemRequestGroup<ThrowOnError extends boolean = true>(
    options: Options<CreateItemRequestGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateItemRequestGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-request-groups',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Item Request
   */
  public static deleteItemRequestGroup<ThrowOnError extends boolean = true>(
    options: Options<DeleteItemRequestGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteItemRequestGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-request-groups/{itemRequestGroupId}',
      ...options,
    });
  }

  /**
   * Update Item Request Group
   */
  public static updateItemRequestGroup<ThrowOnError extends boolean = true>(
    options: Options<UpdateItemRequestGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateItemRequestGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-request-groups/{itemRequestGroupId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Submit Public Item Request
   */
  public static submitPublicItemRequest<ThrowOnError extends boolean = true>(
    options: Options<SubmitPublicItemRequestData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SubmitPublicItemRequestResponse,
      unknown,
      ThrowOnError
    >({
      url: '/v1/organizations/{organizationId}/item-requests/public/{itemRequestId}/submit',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Submit Item Request
   */
  public static submitItemRequest<ThrowOnError extends boolean = true>(
    options: Options<SubmitItemRequestData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SubmitItemRequestResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-requests/all/{itemRequestId}/submit',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Custom Field
   */
  public static createCustomField<ThrowOnError extends boolean = true>(
    options: Options<CreateCustomFieldData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateCustomFieldResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/custom-fields',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Custom Field Collection
   */
  public static createCustomFieldCollection<
    ThrowOnError extends boolean = true
  >(options: Options<CreateCustomFieldCollectionData, ThrowOnError>) {
    return (options?.client ?? client).post<
      CreateCustomFieldCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/custom-field-collections',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Custom Field Form Groups
   */
  public static findCustomFieldFormGroups<ThrowOnError extends boolean = true>(
    options: Options<FindCustomFieldFormGroupsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindCustomFieldFormGroupsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/custom-field-form-groups',
      ...options,
    });
  }

  /**
   * Create Custom Field Form Group
   */
  public static createCustomFieldFormGroup<ThrowOnError extends boolean = true>(
    options: Options<CreateCustomFieldFormGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateCustomFieldFormGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/custom-field-form-groups',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Label Collection
   */
  public static createLabelCollection<ThrowOnError extends boolean = true>(
    options: Options<CreateLabelCollectionData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateLabelCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/label-collections',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Label
   */
  public static createLabel<ThrowOnError extends boolean = true>(
    options: Options<CreateLabelData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateLabelResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/labels',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Lane Collection
   */
  public static createLaneCollection<ThrowOnError extends boolean = true>(
    options: Options<CreateLaneCollectionData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateLaneCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/lane-collections',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Lane
   */
  public static createLane<ThrowOnError extends boolean = true>(
    options: Options<CreateLaneData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateLaneResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/lanes',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Estimate Option Collection
   */
  public static createEstimateOptionCollection<
    ThrowOnError extends boolean = true
  >(options: Options<CreateEstimateOptionCollectionData, ThrowOnError>) {
    return (options?.client ?? client).post<
      CreateEstimateOptionCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/estimate-option-collections',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Estimate Option
   */
  public static createEstimateOption<ThrowOnError extends boolean = true>(
    options: Options<CreateEstimateOptionData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateEstimateOptionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/estimate-options',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Priority
   */
  public static createPriority<ThrowOnError extends boolean = true>(
    options: Options<CreatePriorityData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreatePriorityResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/priorities',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Priority Collection
   */
  public static createPriorityCollection<ThrowOnError extends boolean = true>(
    options: Options<CreatePriorityCollectionData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreatePriorityCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/priority-collections',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Custom Field
   */
  public static deleteCustomField<ThrowOnError extends boolean = true>(
    options: Options<DeleteCustomFieldData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteCustomFieldResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/custom-fields/{customFieldId}',
      ...options,
    });
  }

  /**
   * Update Custom Field
   */
  public static updateCustomField<ThrowOnError extends boolean = true>(
    options: Options<UpdateCustomFieldData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateCustomFieldResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/custom-fields/{customFieldId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Custom Field Form Group
   */
  public static deleteCustomFieldFormGroup<ThrowOnError extends boolean = true>(
    options: Options<DeleteCustomFieldFormGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteCustomFieldFormGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/custom-field-form-groups/{customFieldFormGroupId}',
      ...options,
    });
  }

  /**
   * Update Custom Field Form Group
   */
  public static updateCustomFieldFormGroup<ThrowOnError extends boolean = true>(
    options: Options<UpdateCustomFieldFormGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateCustomFieldFormGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/custom-field-form-groups/{customFieldFormGroupId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Custom Field Collection
   */
  public static deleteCustomFieldCollection<
    ThrowOnError extends boolean = true
  >(options: Options<DeleteCustomFieldCollectionData, ThrowOnError>) {
    return (options?.client ?? client).delete<
      DeleteCustomFieldCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/custom-field-collections/{customFieldCollectionId}',
      ...options,
    });
  }

  /**
   * Update Custom Field Collection
   */
  public static updateCustomFieldCollection<
    ThrowOnError extends boolean = true
  >(options: Options<UpdateCustomFieldCollectionData, ThrowOnError>) {
    return (options?.client ?? client).patch<
      UpdateCustomFieldCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/custom-field-collections/{customFieldCollectionId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Estimate Option
   */
  public static deleteEstimateOption<ThrowOnError extends boolean = true>(
    options: Options<DeleteEstimateOptionData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteEstimateOptionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/estimate-options/{estimateOptionId}',
      ...options,
    });
  }

  /**
   * Update Estimate Option
   */
  public static updateEstimateOption<ThrowOnError extends boolean = true>(
    options: Options<UpdateEstimateOptionData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateEstimateOptionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/estimate-options/{estimateOptionId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Estimate Option Collection
   */
  public static deleteEstimateOptionCollection<
    ThrowOnError extends boolean = true
  >(options: Options<DeleteEstimateOptionCollectionData, ThrowOnError>) {
    return (options?.client ?? client).delete<
      DeleteEstimateOptionCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/estimate-option-collections/{estimateOptionCollectionId}',
      ...options,
    });
  }

  /**
   * Update Estimate Option Collection
   */
  public static updateEstimateOptionCollection<
    ThrowOnError extends boolean = true
  >(options: Options<UpdateEstimateOptionCollectionData, ThrowOnError>) {
    return (options?.client ?? client).patch<
      UpdateEstimateOptionCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/estimate-option-collections/{estimateOptionCollectionId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Label
   */
  public static deleteLabel<ThrowOnError extends boolean = true>(
    options: Options<DeleteLabelData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteLabelResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/labels/{labelId}',
      ...options,
    });
  }

  /**
   * Update Label
   */
  public static updateLabel<ThrowOnError extends boolean = true>(
    options: Options<UpdateLabelData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateLabelResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/labels/{labelId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Label Collection
   */
  public static deleteLabelCollection<ThrowOnError extends boolean = true>(
    options: Options<DeleteLabelCollectionData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteLabelCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/label-collections/{labelCollectionId}',
      ...options,
    });
  }

  /**
   * Update Label Collection
   */
  public static updateLabelCollection<ThrowOnError extends boolean = true>(
    options: Options<UpdateLabelCollectionData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateLabelCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/label-collections/{labelCollectionId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Lane
   */
  public static deleteLane<ThrowOnError extends boolean = true>(
    options: Options<DeleteLaneData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteLaneResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/lanes/{laneId}',
      ...options,
    });
  }

  /**
   * Update Lane
   */
  public static updateLane<ThrowOnError extends boolean = true>(
    options: Options<UpdateLaneData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateLaneResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/lanes/{laneId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Lane Collection
   */
  public static deleteLaneCollection<ThrowOnError extends boolean = true>(
    options: Options<DeleteLaneCollectionData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteLaneCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/lane-collections/{laneCollectionId}',
      ...options,
    });
  }

  /**
   * Update Lane Collection
   */
  public static updateLaneCollection<ThrowOnError extends boolean = true>(
    options: Options<UpdateLaneCollectionData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateLaneCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/lane-collections/{laneCollectionId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Priority
   */
  public static deletePriority<ThrowOnError extends boolean = true>(
    options: Options<DeletePriorityData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeletePriorityResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/priorities/{priorityId}',
      ...options,
    });
  }

  /**
   * Update Priority
   */
  public static updatePriority<ThrowOnError extends boolean = true>(
    options: Options<UpdatePriorityData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdatePriorityResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/priorities/{priorityId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Priority Collection
   */
  public static deletePriorityCollection<ThrowOnError extends boolean = true>(
    options: Options<DeletePriorityCollectionData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeletePriorityCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/priority-collections/{priorityCollectionId}',
      ...options,
    });
  }

  /**
   * Update Priority Collection
   */
  public static updatePriorityCollection<ThrowOnError extends boolean = true>(
    options: Options<UpdatePriorityCollectionData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdatePriorityCollectionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/priority-collections/{priorityCollectionId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Organizations
   */
  public static findOrganizations<ThrowOnError extends boolean = true>(
    options?: Options<FindOrganizationsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindOrganizationsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/admin/organizations/all',
      ...options,
    });
  }

  /**
   * Check If Organization Exists
   */
  public static checkIfOrganizationExists<ThrowOnError extends boolean = true>(
    options: Options<CheckIfOrganizationExistsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CheckIfOrganizationExistsResponse,
      unknown,
      ThrowOnError
    >({
      url: '/v1/organizations/exists',
      ...options,
    });
  }

  /**
   * Find Organizations By Domain
   */
  public static findOrganizationsByDomain<ThrowOnError extends boolean = true>(
    options: Options<FindOrganizationsByDomainData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindOrganizationsByDomainResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/domains/{domain}',
      ...options,
    });
  }

  /**
   * Get Item Request By Id
   */
  public static getItemRequestById<ThrowOnError extends boolean = true>(
    options: Options<GetItemRequestByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetItemRequestByIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/item-requests/all/{itemRequestId}',
      ...options,
    });
  }

  /**
   * Get Public Item Request By Id
   */
  public static getPublicItemRequestById<ThrowOnError extends boolean = true>(
    options: Options<GetPublicItemRequestByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetPublicItemRequestByIdResponse,
      unknown,
      ThrowOnError
    >({
      url: '/v1/organizations/{organizationId}/item-requests/public/{itemRequestId}',
      ...options,
    });
  }

  /**
   * Get Public Item Request Upload Url
   */
  public static getPublicItemRequestUploadUrl<
    ThrowOnError extends boolean = true
  >(options: Options<GetPublicItemRequestUploadUrlData, ThrowOnError>) {
    return (options?.client ?? client).post<
      GetPublicItemRequestUploadUrlResponse,
      unknown,
      ThrowOnError
    >({
      url: '/v1/organizations/{organizationId}/item-requests/public/{itemRequestId}/get-upload-url',
      ...options,
    });
  }

  /**
   * Get Public Stored View By Id
   */
  public static getPublicStoredViewById<ThrowOnError extends boolean = true>(
    options: Options<GetPublicStoredViewByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetPublicStoredViewByIdResponse,
      unknown,
      ThrowOnError
    >({
      url: '/v1/organizations/{organizationId}/stored-views/public/{storedViewId}',
      ...options,
    });
  }

  /**
   * Get Database Connection Details
   * Returns decrypted connection details for BI tools like Metabase. Only available for active credentials. Requires Admin or Owner role.
   */
  public static getConnectionDetails<ThrowOnError extends boolean = true>(
    options: Options<GetConnectionDetailsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetConnectionDetailsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/database-credentials/details',
      ...options,
    });
  }
}

export class PusherService {
  /**
   * Get Pusher Auth
   */
  public static getPusherAuth<ThrowOnError extends boolean = true>(
    options: Options<GetPusherAuthData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetPusherAuthResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/pusher/authenticate',
      ...options,
    });
  }

  /**
   * Get Pusher Event By Id
   */
  public static getPusherEventById<ThrowOnError extends boolean = true>(
    options: Options<GetPusherEventByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetPusherEventByIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/pusher/events/{eventId}',
      ...options,
    });
  }
}

export class RoadmapService {
  /**
   * Find Roadmaps
   */
  public static findRoadmaps<ThrowOnError extends boolean = true>(
    options: Options<FindRoadmapsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindRoadmapsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/roadmaps',
      ...options,
    });
  }

  /**
   * Create Roadmap
   */
  public static createRoadmap<ThrowOnError extends boolean = true>(
    options: Options<CreateRoadmapData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateRoadmapResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/roadmaps',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Roadmap
   */
  public static deleteRoadmap<ThrowOnError extends boolean = true>(
    options: Options<DeleteRoadmapData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteRoadmapResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/roadmaps/{roadmapId}',
      ...options,
    });
  }

  /**
   * Get Roadmap By Id
   */
  public static getRoadmapById<ThrowOnError extends boolean = true>(
    options: Options<GetRoadmapByIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetRoadmapByIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/roadmaps/{roadmapId}',
      ...options,
    });
  }

  /**
   * Update Roadmap
   */
  public static updateRoadmap<ThrowOnError extends boolean = true>(
    options: Options<UpdateRoadmapData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateRoadmapResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/roadmaps/{roadmapId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Initiative
   */
  public static createInitiative<ThrowOnError extends boolean = true>(
    options: Options<CreateInitiativeData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateInitiativeResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/initiatives',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Initiative
   */
  public static deleteInitiative<ThrowOnError extends boolean = true>(
    options: Options<DeleteInitiativeData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteInitiativeResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/initiatives/{initiativeId}',
      ...options,
    });
  }

  /**
   * Update Initiative
   */
  public static updateInitiative<ThrowOnError extends boolean = true>(
    options: Options<UpdateInitiativeData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateInitiativeResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/initiatives/{initiativeId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Milestone
   */
  public static createMilestone<ThrowOnError extends boolean = true>(
    options: Options<CreateMilestoneData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateMilestoneResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/milestones',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Milestone
   */
  public static deleteMilestone<ThrowOnError extends boolean = true>(
    options: Options<DeleteMilestoneData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteMilestoneResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/milestones/{milestoneId}',
      ...options,
    });
  }

  /**
   * Update Milestone
   */
  public static updateMilestone<ThrowOnError extends boolean = true>(
    options: Options<UpdateMilestoneData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateMilestoneResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/milestones/{milestoneId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Scenario
   */
  public static createScenario<ThrowOnError extends boolean = true>(
    options: Options<CreateScenarioData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateScenarioResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/scenarios',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Scenario
   */
  public static deleteScenario<ThrowOnError extends boolean = true>(
    options: Options<DeleteScenarioData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteScenarioResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/scenarios/{scenarioId}',
      ...options,
    });
  }

  /**
   * Update Scenario
   */
  public static updateScenario<ThrowOnError extends boolean = true>(
    options: Options<UpdateScenarioData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateScenarioResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/scenarios/{scenarioId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Roadmap Groups
   */
  public static findRoadmapGroups<ThrowOnError extends boolean = true>(
    options: Options<FindRoadmapGroupsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindRoadmapGroupsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/roadmap-groups',
      ...options,
    });
  }

  /**
   * Create Roadmap Group
   */
  public static createRoadmapGroup<ThrowOnError extends boolean = true>(
    options: Options<CreateRoadmapGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateRoadmapGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/roadmap-groups',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Roadmap Group
   */
  public static deleteRoadmapGroup<ThrowOnError extends boolean = true>(
    options: Options<DeleteRoadmapGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteRoadmapGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/roadmap-groups/{roadmapGroupId}',
      ...options,
    });
  }

  /**
   * Update Roadmap Group
   */
  public static updateRoadmapGroup<ThrowOnError extends boolean = true>(
    options: Options<UpdateRoadmapGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateRoadmapGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/roadmap-groups/{roadmapGroupId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Update Roadmap Item
   */
  public static updateRoadmapItem<ThrowOnError extends boolean = true>(
    options: Options<UpdateRoadmapItemData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateRoadmapItemResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/roadmaps/{roadmapId}/items/{itemNumber}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }
}

export class SlackIntegrationService {
  /**
   * Delete Slack Installation
   */
  public static deleteSlackInstallation<ThrowOnError extends boolean = true>(
    options: Options<DeleteSlackInstallationData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteSlackInstallationResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/integrations/slack/{organizationId}/{workspaceId}',
      ...options,
    });
  }

  /**
   * Initiate Slack OAuth
   */
  public static initiateSlackOAuth<ThrowOnError extends boolean = true>(
    options: Options<InitiateSlackOAuthData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      InitiateSlackOAuthResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/integrations/slack/{organizationId}/oauth/initiate',
      ...options,
    });
  }

  /**
   * Slack OAuth Callback
   */
  public static slackOAuthCallback<ThrowOnError extends boolean = true>(
    options: Options<SlackOAuthCallbackData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
      url: '/v1/integrations/slack/oauth/callback',
      ...options,
    });
  }

  /**
   * Find Slack Installations By OrganizationId
   */
  public static findSlackInstallationsByOrganizationId<
    ThrowOnError extends boolean = true
  >(
    options: Options<FindSlackInstallationsByOrganizationIdData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindSlackInstallationsByOrganizationIdResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/integrations/slack/{organizationId}',
      ...options,
    });
  }
}

export class SubscriptionsService {
  /**
   * Check if Payment Methods exists
   */
  public static checkIfPaymentMethodsExists<
    ThrowOnError extends boolean = true
  >(options: Options<CheckIfPaymentMethodsExistsData, ThrowOnError>) {
    return (options?.client ?? client).get<
      CheckIfPaymentMethodsExistsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/subscriptions/{organizationId}/payment-methods/exists',
      ...options,
    });
  }

  /**
   * Get Payment Methods
   */
  public static getPaymentMethods<ThrowOnError extends boolean = true>(
    options: Options<GetPaymentMethodsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetPaymentMethodsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/subscriptions/{organizationId}/payment-methods',
      ...options,
    });
  }

  /**
   * Get Subscription Invoices
   */
  public static getSubscriptionInvoices<ThrowOnError extends boolean = true>(
    options: Options<GetSubscriptionInvoicesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetSubscriptionInvoicesResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/subscriptions/{organizationId}/invoices',
      ...options,
    });
  }

  /**
   * Get Products
   */
  public static getProducts<ThrowOnError extends boolean = true>(
    options: Options<GetProductsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetProductsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/subscriptions/{organizationId}/products',
      ...options,
    });
  }

  /**
   * Get Customer
   */
  public static getCustomer<ThrowOnError extends boolean = true>(
    options: Options<GetCustomerData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetCustomerResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/subscriptions/{organizationId}/customer',
      ...options,
    });
  }

  /**
   * Setup Payment Method
   */
  public static setupPaymentMethod<ThrowOnError extends boolean = true>(
    options: Options<SetupPaymentMethodData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SetupPaymentMethodResponse2,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/subscriptions/{organizationId}/setup',
      ...options,
    });
  }

  /**
   * Set Default Payment Method
   */
  public static setDefaultPaymentMethod<ThrowOnError extends boolean = true>(
    options: Options<SetDefaultPaymentMethodData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SetDefaultPaymentMethodResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/subscriptions/{organizationId}/set-default-payment-method',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Payment Method
   */
  public static deletePaymentMethod<ThrowOnError extends boolean = true>(
    options: Options<DeletePaymentMethodData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeletePaymentMethodResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/subscriptions/{organizationId}/payment-methods/{paymentMethodId}',
      ...options,
    });
  }

  /**
   * Create Subscription
   */
  public static createSubscription<ThrowOnError extends boolean = true>(
    options: Options<CreateSubscriptionData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateSubscriptionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: 'v1/subscriptions/{organizationId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Update Subscription
   */
  public static updateSubscription<ThrowOnError extends boolean = true>(
    options: Options<UpdateSubscriptionData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateSubscriptionResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/subscriptions/{organizationId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Product
   */
  public static createProduct<ThrowOnError extends boolean = true>(
    options?: Options<CreateProductData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateProductResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/admin/subscriptions/products',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Update Product
   */
  public static updateProduct<ThrowOnError extends boolean = true>(
    options: Options<UpdateProductData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateProductResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/admin/subscriptions/products/{productId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }
}

export class TimeTrackingService {
  /**
   * Find Time Entries
   */
  public static findTimeEntries<ThrowOnError extends boolean = true>(
    options: Options<FindTimeEntriesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindTimeEntriesResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/time-entries',
      ...options,
    });
  }

  /**
   * Create Time Entry
   */
  public static createTimeEntry<ThrowOnError extends boolean = true>(
    options: Options<CreateTimeEntryData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateTimeEntryResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/time-entries',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Time Entry
   */
  public static deleteTimeEntry<ThrowOnError extends boolean = true>(
    options: Options<DeleteTimeEntryData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteTimeEntryResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/time-entries/{timeEntryId}',
      ...options,
    });
  }

  /**
   * Update Time Entry
   */
  public static updateTimeEntry<ThrowOnError extends boolean = true>(
    options: Options<UpdateTimeEntryData, ThrowOnError>
  ) {
    return (options?.client ?? client).put<
      UpdateTimeEntryResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/time-entries/{timeEntryId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Get Active Time Entry
   */
  public static getActiveTimeEntry<ThrowOnError extends boolean = true>(
    options: Options<GetActiveTimeEntryData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetActiveTimeEntryResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/time-entries/active',
      ...options,
    });
  }
}

export class WorkflowService {
  /**
   * Find Workflows
   */
  public static findWorkflows<ThrowOnError extends boolean = true>(
    options: Options<FindWorkflowsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindWorkflowsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/workflows',
      ...options,
    });
  }

  /**
   * Create Workflow
   */
  public static createWorkflow<ThrowOnError extends boolean = true>(
    options: Options<CreateWorkflowData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateWorkflowResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/workflows',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Workflow Groups
   */
  public static findWorkflowGroups<ThrowOnError extends boolean = true>(
    options: Options<FindWorkflowGroupsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindWorkflowGroupsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/workflow-groups',
      ...options,
    });
  }

  /**
   * Create Workflow Group
   */
  public static createWorkflowGroup<ThrowOnError extends boolean = true>(
    options: Options<CreateWorkflowGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateWorkflowGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/workflow-groups',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Find Workflow Runs
   */
  public static findWorkflowRuns<ThrowOnError extends boolean = true>(
    options: Options<FindWorkflowRunsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      FindWorkflowRunsResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/workflow-runs',
      ...options,
    });
  }

  /**
   * Delete Workflow
   */
  public static deleteWorkflow<ThrowOnError extends boolean = true>(
    options: Options<DeleteWorkflowData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteWorkflowResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/workflows/{workflowId}',
      ...options,
    });
  }

  /**
   * Update Workflow
   */
  public static updateWorkflow<ThrowOnError extends boolean = true>(
    options: Options<UpdateWorkflowData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateWorkflowResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/workflows/{workflowId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Delete Workflow Group
   */
  public static deleteWorkflowGroup<ThrowOnError extends boolean = true>(
    options: Options<DeleteWorkflowGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteWorkflowGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/workflow-groups/{workflowGroupId}',
      ...options,
    });
  }

  /**
   * Update Workflow Group
   */
  public static updateWorkflowGroup<ThrowOnError extends boolean = true>(
    options: Options<UpdateWorkflowGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateWorkflowGroupResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/workflow-groups/{workflowGroupId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Create Webhook
   */
  public static createWebhook<ThrowOnError extends boolean = true>(
    options: Options<CreateWebhookData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateWebhookResponse,
      unknown,
      ThrowOnError
    >({
      security: [
        {
          name: 'Authorization',
          type: 'apiKey',
        },
      ],
      url: '/v1/organizations/{organizationId}/webhooks',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }

  /**
   * Trigger Webhook Workflows
   */
  public static triggerWebhookWorkflows<ThrowOnError extends boolean = true>(
    options: Options<TriggerWebhookWorkflowsData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      TriggerWebhookWorkflowsResponse,
      unknown,
      ThrowOnError
    >({
      url: '/v1/organizations/{organizationId}/webhooks/{webhookId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
  }
}
